function ErrorFallback({ error }) {
  return <p>Sentry has detected an error, attempting to reload the application...</p>;
}

export default ErrorFallback;